import ProjectSession from "../../../core/model2/project/project-session"
import {EVENT_BUS_MENU_RERENDER} from "../sections/const"
import NavigationMenu_ProjectsLocalSettings from "../local-settings"
import {SpaceProto} from "../../../core/model2/space/space-proto"

export default function menu_collapseAllProjects(space: SpaceProto, localSettings?: NavigationMenu_ProjectsLocalSettings) {
    const collapsedProjects: ID[] = []

    const recursiveCollapse = (project:ProjectSession) => {
        if (project.isSection) return // skip sections and all its children

        collapsedProjects.push(project.id)

        _.map(project.treeChildren, (childProject: ProjectSession) => {
            recursiveCollapse(childProject)
        })
    }

    _.map(space.rootProjects, (project: ProjectSession) => {
        recursiveCollapse(project)
    })

    if (localSettings) {
        localSettings.expandedProjects = _.difference(localSettings.expandedProjects, collapsedProjects)
        localSettings.save()
    }

    gd.bus.triggerEvent(EVENT_BUS_MENU_RERENDER)
}